<div class="p-4">
  <h2>Debug: Token claims</h2>
  <p class="text-muted">Keycloak token shape (company_roles, groups)</p>

  <ng-container *ngIf="keycloak.enabled && keycloak.authenticated; else notAuth">
    <section class="mb-4">
      <h3>Decoded access token</h3>
      <pre class="bg-light p-3 rounded">{{ decodedToken | json }}</pre>
    </section>
    <section class="mb-4">
      <h3>Extracted</h3>
      <ul>
        <li>
          <strong>Username:</strong>
          {{ keycloak.username }}
        </li>
        <li>
          <strong>Company (active):</strong>
          {{ activeCompany ?? '(none)' }}
        </li>
        <li>
          <strong>company_roles (slim JWT):</strong>
          <pre class="bg-light p-2 rounded small">{{ keycloak.companyRoles | json }}</pre>
        </li>
        <li>
          <strong>Company (legacy claim):</strong>
          {{ keycloak.company ?? '(none)' }}
        </li>
        <li>
          <strong>Groups:</strong>
          {{ keycloak.groups | json }}
        </li>
      </ul>
    </section>
    <section class="mb-4">
      <h3>Groups ({{ groupsList.length }})</h3>
      <pre class="bg-light p-3 rounded small">{{ groupsList | json }}</pre>
    </section>
  </ng-container>
  <ng-template #notAuth>
    <p>
      Not authenticated with Keycloak.
      <a routerLink="/auth/login">Log in</a>
      .
    </p>
  </ng-template>

  <button type="button" class="btn btn-secondary" (click)="goBack()">
    Back to dashboard
  </button>
</div>
